// extracted by mini-css-extract-plugin
export default {"content":"BaseItem_content__s3SLG","value":"BaseItem_value__CZ4Y6","key":"BaseItem_key__4Oqac","key_value":"BaseItem_key_value__DllIQ"};